import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';

import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.puestos;

// Axios instance with auth interceptor (token managed automatically)
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'puestos',
  defaultTtl: '15m',
  hashLargeSegments: true,
  emitMeta: true,
});


// get all puestos by local id
export const getPuestosByLocalId = async (localId: string) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetPuestosByLocalId/${localId}`));
};

// /UpdatePuestos/<int:puesto_id>
export const updatePuesto = async (puestosId: number, puestosData: any) => {
  const res = await retryWithBackoff(() => api.put(`/UpdatePuesto/${puestosId}`, puestosData));
  await cachedApi.clear();
  return res;
};

export const createPuesto = async (puestosData: any) => {
  const res = await retryWithBackoff(() => api.post('/CreatePuesto', puestosData));
  await cachedApi.clear();
  return res;
};

export const deletePuestoById = async (puestosId: number) => {
  const res = await retryWithBackoff(() => api.delete(`/DeletePuesto/${puestosId}`));
  await cachedApi.clear();
  return res;
};

// get puesto by id
export const getPuestoById = async (puestosId: number) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetPuestoById/${puestosId}`));
};


export const CreatePuestoRegistration = async (puestosData: any) => {
  const res = await retryWithBackoff(() => api.post('/CreatePuestoRegistration', puestosData));
  await cachedApi.clear();
  return res;
};

export const DeletePuestoRegistration = async (code: string) => {
  const res = await retryWithBackoff(() => api.delete(`/DeletePuestoRegistration/${code}`));
  await cachedApi.clear();
  return res;
};

export const createPuestoFromListRegistration = async (puestoData: any) => {
  const res = await retryWithBackoff(() => api.post('/CreatePuestoFromListRegistration', puestoData));
  await cachedApi.clear();
  return res;
};

export const DeletePuestosSelected = async (puestos: string[]) => {
  const res = await retryWithBackoff(() => api.delete('/DeletePuestos', {
    data: {
      puestos_to_delete: puestos,
    }
  }));
  await cachedApi.clear();
  return res;
};
